import gql from 'graphql-tag'
//
// 아래는 이해를 돕기 위한 예시입니다. 이와 같은 방식으로 처리해 줄 수 있습니다.
//
export var createFileProcessor = function () {
  var addGQL =
    'mutation createPostImageFile($data: PostImageFileCreationInput) {\n  createPostImageFile(data: $data) {\n    ok\n  }\n}'
  var removeGQL =
    'mutation removePostImageFiles($data: PostImageFilesDeleteInput) {\n  deletePostImageFiles(data: $data) {\n    ok\n  }\n}'
  var processor = {
    add: function (client, localFile) {
      return client.mutate({ mutation: gql(addGQL), variables: { file: localFile } })
    },
    remove: function (client, serverFile) {
      return client.mutate({
        mutation: gql(removeGQL),
        variables: {
          fileIds: serverFile.map(function (f) {
            return f.postImageId
          }),
        },
      })
    },
  }
  return processor
}
//# sourceMappingURL=FileProcessor.js.map
